import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: {
        bid: 0,
        asc: 0
    }
};
export var BidAscReducer = createSlice({
    name: 'bidAsc',
    initialState: initialState,
    reducers: {
        set: function set(state, payloadAction) {
            state.data = payloadAction.payload;
        }
    }
});
var set = BidAscReducer.actions.set;
export { set };
export default BidAscReducer.reducer;
